import { McpConnectInstructions } from "./mcp-connect-instructions";
import { ClaudeCodeInstructions } from "./claude-code-instructions";
import { CodexInstructions } from "./codex-instructions";
import { CursorInstructions } from "./cursor-instructions";
import {
    type McpClientId,
    type McpCredential,
    PLACEHOLDER_API_KEY,
} from "../../lib/mcp-clients";

// // // //

const PLACEHOLDER_OAUTH = {
    clientId: "your-client-id",
    clientSecret: "your-client-secret",
} as const;

/**
 * ClientInstructions
 * Renders the setup instructions for the selected MCP client. Pass a
 * `credential` for the live view (real values, copy on); omit it for the static
 * placeholder preview (copy off).
 */
export function ClientInstructions(props: {
    client: McpClientId;
    credential?: McpCredential;
    enableCopy?: boolean;
}) {
    const { client, credential, enableCopy = true } = props;

    switch (client) {
        case "claude": {
            const oauth =
                credential?.kind === "oauth" ? credential : PLACEHOLDER_OAUTH;
            return (
                <McpConnectInstructions
                    client={{
                        clientId: oauth.clientId,
                        clientSecret: oauth.clientSecret,
                    }}
                    enableCopy={enableCopy}
                />
            );
        }
        case "claude-code": {
            const apiKey =
                credential?.kind === "api-key"
                    ? credential.key
                    : PLACEHOLDER_API_KEY;
            return (
                <ClaudeCodeInstructions
                    apiKey={apiKey}
                    enableCopy={enableCopy}
                />
            );
        }
        case "codex-desktop": {
            const apiKey =
                credential?.kind === "api-key"
                    ? credential.key
                    : PLACEHOLDER_API_KEY;
            return (
                <CodexInstructions apiKey={apiKey} enableCopy={enableCopy} />
            );
        }
        case "cursor": {
            const apiKey =
                credential?.kind === "api-key"
                    ? credential.key
                    : PLACEHOLDER_API_KEY;
            return (
                <CursorInstructions apiKey={apiKey} enableCopy={enableCopy} />
            );
        }
    }
}
